export default __webpack_public_path__ + "static/ally-management-banner-4b02f4bd3f18055a8cd85027fb18e05d.png";